import { Box, Container } from '@mui/material';
import { useParams } from 'react-router-dom';

import { ContractDetailSeller } from '@/components/ContractDetailSeller/ContractDetailSeller';

export const SellerAddContractDetailPage = () => {
  const { contractId } = useParams();
  console.log(contractId);
  if (!contractId) {
    return null;
  }

  return (
    <Container sx={{ py: '40px' }}>
      <ContractDetailSeller uid={contractId} />
    </Container>
  );
};
